import {override} from 'mobx';
import {CompetitorPlayerStatsModuleSportModel} from "./competitor-player-stats.module.sport-model";
import {EventChartHalfCourtRequestParams} from "../../../../core/icons/images/court/event-chart.half-court.request-params";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";

export class CompetitorPlayerStatsModuleBasketballModel extends CompetitorPlayerStatsModuleSportModel {
  @override get shouldRenderAnimation(): Number {
    return false;
  }

  @override get shouldRenderSelector(): Number {
    return false;
  }

  @override get contextClassName(): Number {
    return ''
  }

  @override get courtRatio(): Number {
    return COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.COURT_RATIO.basketball
  }

  @override get courtType(): Number {
    return EventChartHalfCourtRequestParams
  }
}